import {
	GlobalContainerSettings,
	HeaderSettings,
	MainSettings,
	FooterSettings,
	Text,
	TextTitle,
} from './styles';
import { BottomNavigations } from '../../components';
import { useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';

function About() {
	const { i18n } = useTranslation();

	return (
		<GlobalContainerSettings>
			<HeaderSettings>{`${i18n.t('aboutUs')}`}</HeaderSettings>
			<MainSettings>
				<TextTitle>{`${i18n.t('aboutUsTitleOne')}`} </TextTitle>
				<Text>
					{`${i18n.t('aboutUsSectionOne')}`}

					<Link
						href={`https://${i18n.t('aboutUsSectionTwo')}`}
						target="_blank"
						rel="noopener noreferrer"
						sx={{ color: 'primary.main', textDecoration: 'underline' }}
					>
						{i18n.t('aboutUsSectionTwo')}
					</Link>
				</Text>

				<TextTitle sx={{ marginTop: '38px' }}>
					{`${i18n.t('aboutUsTitleTwo')}`}
				</TextTitle>

				<Text>{`${i18n.t('aboutUsSectionThree')}`}</Text>
			</MainSettings>

			<FooterSettings>
				<BottomNavigations current="settings" />
			</FooterSettings>
		</GlobalContainerSettings>
	);
}

export default About;
